export default __webpack_public_path__ + "static/media/coil.bbfdc1b3.png";